import styles from './PageProductCallToActionRenew.module.css';
import PageProductCallToActionRenewPrice from './PageProductCallToActionRenewPrice.js';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import LinkAuthFlow from './LinkAuthFlow.js';
function PageProductCallToActionRenew(props) {
  const {
    flexDirection,
    margin,
    boxShadow,
    orTextColor,
    callToActionTextOverride,
  } = props;
  const {
    showCallToActionRenewAtCurrentRateButton,
    callToActionDefaultText,
    productSku,
  } = useSearchParamOrDefaultProps();

  const callToActionText = callToActionTextOverride
    ? callToActionTextOverride
    : callToActionDefaultText || 'RENEW AT\nCURRENT RATE';

  return (
    <div
      className={styles.PageProductRenewCallToAction}
      style={{ flexDirection, margin }}
    >
      <LinkAuthFlow
        boxShadow={boxShadow}
        modalType={'signUp'}
        contentType={'page'}
        productSku={productSku}
      >
        <PageProductCallToActionRenewPrice />
      </LinkAuthFlow>
      {showCallToActionRenewAtCurrentRateButton === 'true' && (
        <span style={{ color: orTextColor }} className={classNames(styles.or)}>
          OR
        </span>
      )}
      {showCallToActionRenewAtCurrentRateButton === 'true' && (
        <div className={styles.renewCallToActionWrapper}>
          <LinkAuthFlow
            maxWidth={'100%'}
            modalType={'signUp'}
            contentType={'page'}
            productSku={productSku}
            borderRadius={'4px'}
            boxShadow={boxShadow}
            borderWidth={'1px'}
            borderStyle={'solid'}
            display={'flex'}
            justifyContent="center"
            textAlign="center"
            className={styles.renewCallToAction}
          >
            {callToActionText}
          </LinkAuthFlow>
        </div>
      )}
    </div>
  );
}

PageProductCallToActionRenew.propTypes = {
  flexDirection: PropTypes.string,
  margin: PropTypes.string,
  boxShadow: PropTypes.string,
  orTextColor: PropTypes.string,
  callToActionTextOverride: PropTypes.string,
};

export default PageProductCallToActionRenew;
